export default "/static/featured/department.jpg"